import React, { useContext, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';

import ReportActions from '../../../report-actions';
import { EXPORT_EXCEL, EXPORT_PDF, EXPORT_CSV } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { ReportsContext } from '../../../context';
import {
  DATE_RANGE_PROPS,
  STORE_PROPS,
  LABEL_PROVIDER_PROPS,
  SHIPPING_ACCOUNT_PROPS,
  SHIPPING_SERVICE_PROPS,
} from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';
import { PARAMETER_NAME_SHIPPING_SERVICE_ID } from '../../../report-filters/report-parameter-names';
import Global from '../../../../../../../store/global-selectors';
import messages from './messages';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_CSV];

const ShippingCost = () => {
  const { labelProviderId, myAccountsForProvider } = useContext(ReportsContext);
  const hasProviderSelected = !!labelProviderId;
  const multiSelections = [
    {
      name: <FormattedMessage {...messages.selectAccount} />,
    },
    ...myAccountsForProvider,
  ];

  const shippingAccountProps = {
    ...SHIPPING_ACCOUNT_PROPS,
    disabled: !hasProviderSelected,
    options: myAccountsForProvider.length > 1 ? multiSelections : myAccountsForProvider,
  };
  const services = useSelector(Global.selectSellerServices);
  const allowableServices = useMemo(() => {
    const reducedServices = services
      .filter((srv) => srv.labelProviderId === labelProviderId && !srv.isHidden)
      .reduce((accum, srv) => {
        if (!Object.keys(accum).includes(srv.serviceId)) {
          return {
            ...accum,
            [srv.serviceId]: {
              serviceId: srv.serviceId,
              name: srv.name,
              [PARAMETER_NAME_SHIPPING_SERVICE_ID]: srv.serviceId,
            },
          };
        }
        return accum;
      }, {});
    return Object.values(reducedServices);
  }, [services, labelProviderId]);

  const serviceProps = {
    ...SHIPPING_SERVICE_PROPS,
    options: [...SHIPPING_SERVICE_PROPS.options, ...allowableServices],
  };
  const filtersProps = [DATE_RANGE_PROPS, STORE_PROPS, LABEL_PROVIDER_PROPS, shippingAccountProps, serviceProps];
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);
  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default ShippingCost;
